export default __webpack_public_path__ + "static/media/graceLogo.90108ddd.png";